// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OGIyUa {
  display: flex;
  height: 100dvh;
  background: #f8f9fc;
  color: #24272b;
  font-size: 13px;
  font-family: 'Source Sans 3', Arial, sans-serif;
  line-height: 1.5;
}
.BzVK3r {
  position: relative;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  background: #2a2b2d;
  color: white;
}
.lfLKwC {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  font-size: 16px;
  font-weight: 700;
  white-space: nowrap;
}
.lfLKwC button,
.WWAoN2 {
  color: inherit;
  background: transparent;
  border: 0;
  padding: 8px;
}
.l0MeVY,
.h2IrLp span {
  font-weight: 300;
}
.BzVK3r nav {
  flex: 1;
  padding: 6px 8px;
}
.BzVK3r nav a:hover,
.lVG1dp {
  background: #ffffff26;
}
.BzVK3r nav img {
  width: 16px;
  height: 16px;
  filter: brightness(0) invert(1);
}
.GG1lxJ {
  position: absolute;
  right: 0;
  top: 0;
  width: 6px;
  height: 100%;
  cursor: col-resize;
  touch-action: none;
  padding: 0;
  border: 0;
  background: transparent;
}
.GG1lxJ:hover {
  background: #ffffff40;
}
.sMV0bk {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.eaS5AA {
  height: 56px;
  flex-shrink: 0;
  padding: 0 32px;
  border-bottom: 1px solid #e2e3e5;
  background: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.eaS5AA > div {
  display: flex;
  align-items: center;
  gap: 16px;
}
.eaS5AA strong {
  display: block;
}
.eaS5AA button {
  background: transparent;
  border: 0;
}
.jSdblw,
.itnQe3 {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
}
.jSdblw {
  margin-bottom: 24px;
}
.jSdblw p,
.itnQe3 p {
  color: #70747a;
  margin: 4px 0 0;
}
.rR9zar {
  display: flex;
  align-items: center;
  gap: 8px;
}
.rR9zar button {
  border: 1px solid #d9d9d9;
  background: white;
  border-radius: 6px;
  height: 36px;
  width: 36px;
  font-size: 20px;
}
.e6ovDt,
.aI41Ol {
  background: white;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 24px;
  margin-top: 24px;
}
.mAaj51 {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 16px;
  margin-top: 20px;
}
.Q00a9C {
  border: 1px solid #d9d9d9;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 181px;
  box-shadow: 0 1px 3px #00000014;
}
.Q00a9C h3 {
  font-size: 13px;
  color: #70747a;
  font-weight: 400;
  margin: 0 0 8px;
}
.Q00a9C small {
  font-size: 12px;
  color: #70747a;
}
.FMD9yB span {
  color: #70747a;
}
.O6bO_L {
  color: #c82a37;
}
.aI41Ol {
  text-align: center;
  padding: 40px;
}
.SxBjAP li span {
  color: #ff8000;
  font-size: 20px;
}
@media (max-width: 1023px) {
  .nmnvtX {
    grid-template-columns: 1fr;
  }
  .mhj6FM {
    display: none;
  }
}
.cAaRIc a {
  color: white;
}
@media (max-width: 1450px) {
  .mAaj51 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 1000px) {
  .mAaj51 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .jSdblw {
    flex-wrap: wrap;
  }
  .mhj6FM {
    padding: 32px;
  }
  .mhj6FM h1 {
    font-size: 36px;
  }
}
@media (max-width: 700px) {
  .mAaj51 {
    grid-template-columns: minmax(0, 1fr);
  }
  .BzVK3r {
    max-width: 72px;
  }
  .lfLKwC > span,
  .BzVK3r nav a > :not(img),
  .GG1lxJ {
    display: none;
  }
  .BzVK3r nav a {
    font-size: 0;
    gap: 0;
  }
  .tXDRY6 {
    padding: 16px;
  }
  .eaS5AA {
    padding: 0 16px;
  }
  .itnQe3 {
    flex-wrap: wrap;
  }
  .nmnvtX {
    grid-template-columns: 1fr;
  }
  .mhj6FM {
    display: none;
  }
}

.OGIyUa button,
.OGIyUa input,
.OGIyUa select,
.OGIyUa textarea {
  font-family: inherit;
}
.lfLKwC button {
  padding: 0;
  width: 20px;
  height: 24px;
  font-size: 20px;
}
.BzVK3r nav a {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  margin-bottom: 2px;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}
.BzVK3r nav a.lVG1dp {
  font-weight: 600;
}
.BzVK3r svg {
  flex-shrink: 0;
}
.WWAoN2 {
  border-top: 1px solid #ffffff1a;
  text-align: left;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.eaS5AA > span strong {
  display: inline;
  font-weight: 500;
  color: #24272b;
}
.eaS5AA > span {
  color: #70747a;
}
.T1OTTM {
  position: relative;
}
.F6tGYd {
  text-align: right;
  max-width: 180px;
}
.F6tGYd small {
  font-size: 11px;
  color: #70747a;
}
.F6tGYd strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
  text-transform: capitalize;
}
.LevF1N svg {
  transform: rotate(90deg);
  color: #70747a;
}
.eaS5AA .XKd6ZJ {
  position: absolute;
  right: 0;
  top: 44px;
  padding: 10px 24px;
  background: white;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  box-shadow: 0 2px 4px #0002;
  z-index: 10;
}
.S8AbDH {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  color: white;
  display: grid;
  place-items: center;
  background: #d64000;
  font-weight: 600;
}
.jSdblw p {
  line-height: 19.5px;
}
.rR9zar span {
  min-width: 140px;
  text-align: center;
  text-transform: capitalize;
  font-size: 14px;
  font-weight: 500;
}
.e6ovDt {
  box-shadow: 0 2px 4px #0000001f;
}
.itnQe3 h2 {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  line-height: 28px;
}
.itnQe3 p {
  margin-top: 2px;
}
.aUA5bh {
  margin: 0 8px;
  color: #d9d9d9;
}
.V1awZt {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-items: start;
  color: #d64000;
}
.V1awZt[data-kind='down'] {
  color: #dc2626;
}
.V1awZt[data-kind='up'] {
  color: #059669;
}
.V1awZt h3 {
  margin-bottom: 8px;
  line-height: 20px;
}
.V1awZt svg {
  flex-shrink: 0;
}
.Y5H1Zg {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 12px;
}
.Q00a9C:has(.jJoHIv) {
  min-height: 208px;
}
.jJoHIv {
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  margin-bottom: 2px;
}
.FMD9yB {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  font-size: 13px;
  line-height: 19.5px;
  padding: 2px 0;
}
.FMD9yB strong {
  font-weight: 500;
}
.Q00a9C button {
  border: 1px solid var(--stroke-neutral-silver, #d9d9d9);
  color: var(--text-neutral-dark, #24272b);
  min-height: 37px;
  height: 37px;
  width: 100%;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 4px;
  background: #f8f9fc;
  border-color: #d9d9d9;
}
.Q00a9C button:hover {
  color: #d64000;
  border-color: #d64000;
}

.tXDRY6 {
  overflow: auto;
  padding: 32px;
  flex: 1;
  position: relative;
}
.tXDRY6[data-section='admissoes'] .jSdblw h1,
.tXDRY6[data-section='convidar'] .jSdblw h1,
.tXDRY6[data-section='configuracoes'] .jSdblw h1 {
  font-size: 24px;
  line-height: 32px;
}
.tXDRY6[data-ai='true'] {
  padding: 0;
}
.tXDRY6[data-ai='true'] .jSdblw {
  display: none;
}
.O6bO_L:has(button) {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 12px;
}
.O6bO_L:has(button) button {
  width: auto;
}
@media (min-width: 1536px) {
  .mAaj51 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}
@media (min-width: 1280px) and (max-width: 1535px) {
  .mAaj51 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (min-width: 768px) and (max-width: 1279px) {
  .mAaj51 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 767px) {
  .mAaj51 {
    grid-template-columns: 1fr;
  }
  .BzVK3r nav a > svg {
    display: block;
  }
}

.Y5H1Zg .FMD9yB {
  padding: 0;
}
.Y5H1Zg .FMD9yB strong {
  margin-left: auto;
}
.jSdblw h1 {
  margin: 0;
  font-size: 30px;
  font-weight: 600;
  line-height: 36px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.jSdblw h1 svg {
  color: #d64000;
}
.itnQe3 > button {
  height: 36px;
  min-height: 36px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 4px;
  background: #d64000;
  letter-spacing: normal;
}

.nmnvtX {
  min-height: 100dvh;
  display: grid;
  grid-template-columns: minmax(0, 1.5fr) minmax(0, 1fr);
  font-family: 'Source Sans 3', Arial, sans-serif;
  position: relative;
  background: #2a2b2d;
}
.mAdcRG {
  display: flex;
  align-items: center;
  gap: 8px;
  position: absolute;
  left: 24px;
  top: 24px;
  color: white;
  border: 0;
  border-radius: 4px;
  background: #444547;
  padding: 6px 12px;
  font-size: 12px;
  font-family: inherit;
}
.mhj6FM {
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
  padding: 64px 96px;
  border-right: 1px solid #ffffff14;
}
.mhj6FM h1 span {
  color: #d64000;
}
.mhj6FM p {
  color: #d4d6d8;
  margin: 0;
  max-width: 620px;
  font-size: 18px;
  line-height: 1.625;
}
.HfqjHr {
  font-size: 12px;
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #c64000;
  border-radius: 16px;
  color: white;
  font-weight: 700;
  padding: 4px 12px;
  letter-spacing: 1.2px;
}
.SxBjAP {
  max-width: 640px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 0;
  list-style: none;
  gap: 12px;
  margin: 32px 0;
}
.SxBjAP li {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #ffffff0d;
  border: 1px solid #ffffff1a;
  border-radius: 4px;
  padding: 12px 16px;
  font-weight: 500;
  font-size: 14px;
}
.SxBjAP svg {
  flex-shrink: 0;
  color: #d64000;
}
.KfrICE {
  display: flex;
  font-size: 12px;
  color: #d4d6d8;
  border: 0;
  padding: 0;
  gap: 24px;
}
.KfrICE span {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}
.KfrICE svg {
  color: #d64000;
  flex-shrink: 0;
}
.svp2Od {
  min-width: 0;
  color: var(--bs-body-color, #212529);
  font-family: var(--bs-body-font-family, system-ui);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px;
  background: #2a2b2d;
}
.h2IrLp {
  color: white;
  font-weight: 700;
  font-size: 26px;
  margin-bottom: 36px;
}
.cAaRIc {
  color: white;
  display: flex;
  gap: 16px;
  margin-top: 32px;
  font-size: 12px;
}
.cAaRIc a + a {
  border-left: 1px solid #ffffff40;
  padding-left: 16px;
}
@media (max-width: 1250px) {
  .mhj6FM {
    padding: 48px;
  }
  .mhj6FM h1 {
    font-size: 48px;
  }
  .KfrICE {
    flex-wrap: wrap;
  }
}
@media (max-width: 1023px) {
  .nmnvtX {
    grid-template-columns: 1fr;
  }
  .mhj6FM {
    display: none;
  }
  .svp2Od {
    padding: 64px 24px;
  }
}
.mhj6FM h1 {
  margin: 24px 0 16px;
  font-weight: 700;
  line-height: 1;
  margin-top: 32px;
  margin-bottom: 24px;
  max-width: 672px;
  font-size: 60px;
  letter-spacing: -0.8px;
}

@media (max-width: 700px) {
  .BzVK3r nav a {
    justify-content: center;
  }
  .BzVK3r nav a span,
  .WWAoN2 span {
    display: none;
  }
  .eaS5AA {
    gap: 8px;
  }
  .eaS5AA > span {
    max-width: 120px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .T1OTTM {
    gap: 8px !important;
  }
  .F6tGYd {
    max-width: 80px;
  }
  .T1OTTM > svg {
    display: none;
  }
  .O6bO_L:has(button) {
    flex-wrap: wrap;
  }
  .itnQe3 p {
    overflow-wrap: anywhere;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Bpo/Bpo.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,+CAA+C;EAC/C,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,cAAc;EACd,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,OAAO;EACP,gBAAgB;AAClB;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,SAAS;AACX;AACA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;AACA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;AACF;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,gDAAgD;EAClD;AACF;AACA;EACE;IACE,gDAAgD;EAClD;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,eAAe;EACjB;EACA;;;IAGE,aAAa;EACf;EACA;IACE,YAAY;IACZ,MAAM;EACR;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;AACF;;AAEA;;;;EAIE,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uDAAuD;EACvD,wCAAwC;EACxC,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,OAAO;EACP,kBAAkB;AACpB;AACA;;;EAGE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,gDAAgD;EAClD;AACF;AACA;EACE;IACE,gDAAgD;EAClD;AACF;AACA;EACE;IACE,gDAAgD;EAClD;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sDAAsD;EACtD,+CAA+C;EAC/C,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,SAAS;EACT,UAAU;EACV,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,YAAY;EACZ,oCAAoC;EACpC,kDAAkD;EAClD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;;IAEE,aAAa;EACf;EACA;IACE,QAAQ;EACV;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".shell {\n  display: flex;\n  height: 100dvh;\n  background: #f8f9fc;\n  color: #24272b;\n  font-size: 13px;\n  font-family: 'Source Sans 3', Arial, sans-serif;\n  line-height: 1.5;\n}\n.sidebar {\n  position: relative;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  background: #2a2b2d;\n  color: white;\n}\n.sidebarBrand {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  font-size: 16px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n.sidebarBrand button,\n.support {\n  color: inherit;\n  background: transparent;\n  border: 0;\n  padding: 8px;\n}\n.light,\n.brand span {\n  font-weight: 300;\n}\n.sidebar nav {\n  flex: 1;\n  padding: 6px 8px;\n}\n.sidebar nav a:hover,\n.active {\n  background: #ffffff26;\n}\n.sidebar nav img {\n  width: 16px;\n  height: 16px;\n  filter: brightness(0) invert(1);\n}\n.resize {\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 6px;\n  height: 100%;\n  cursor: col-resize;\n  touch-action: none;\n  padding: 0;\n  border: 0;\n  background: transparent;\n}\n.resize:hover {\n  background: #ffffff40;\n}\n.workspace {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n.header {\n  height: 56px;\n  flex-shrink: 0;\n  padding: 0 32px;\n  border-bottom: 1px solid #e2e3e5;\n  background: white;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.header > div {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n.header strong {\n  display: block;\n}\n.header button {\n  background: transparent;\n  border: 0;\n}\n.title,\n.companyHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n}\n.title {\n  margin-bottom: 24px;\n}\n.title p,\n.companyHeader p {\n  color: #70747a;\n  margin: 4px 0 0;\n}\n.month {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.month button {\n  border: 1px solid #d9d9d9;\n  background: white;\n  border-radius: 6px;\n  height: 36px;\n  width: 36px;\n  font-size: 20px;\n}\n.company,\n.empty {\n  background: white;\n  border: 1px solid #d9d9d9;\n  border-radius: 8px;\n  padding: 24px;\n  margin-top: 24px;\n}\n.metrics {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 16px;\n  margin-top: 20px;\n}\n.metric {\n  border: 1px solid #d9d9d9;\n  border-radius: 12px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 181px;\n  box-shadow: 0 1px 3px #00000014;\n}\n.metric h3 {\n  font-size: 13px;\n  color: #70747a;\n  font-weight: 400;\n  margin: 0 0 8px;\n}\n.metric small {\n  font-size: 12px;\n  color: #70747a;\n}\n.financialRow span {\n  color: #70747a;\n}\n.error {\n  color: #c82a37;\n}\n.empty {\n  text-align: center;\n  padding: 40px;\n}\n.heroFeatures li span {\n  color: #ff8000;\n  font-size: 20px;\n}\n@media (max-width: 1023px) {\n  .login {\n    grid-template-columns: 1fr;\n  }\n  .hero {\n    display: none;\n  }\n}\n.loginFooter a {\n  color: white;\n}\n@media (max-width: 1450px) {\n  .metrics {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n@media (max-width: 1000px) {\n  .metrics {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .title {\n    flex-wrap: wrap;\n  }\n  .hero {\n    padding: 32px;\n  }\n  .hero h1 {\n    font-size: 36px;\n  }\n}\n@media (max-width: 700px) {\n  .metrics {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .sidebar {\n    max-width: 72px;\n  }\n  .sidebarBrand > span,\n  .sidebar nav a > :not(img),\n  .resize {\n    display: none;\n  }\n  .sidebar nav a {\n    font-size: 0;\n    gap: 0;\n  }\n  .main {\n    padding: 16px;\n  }\n  .header {\n    padding: 0 16px;\n  }\n  .companyHeader {\n    flex-wrap: wrap;\n  }\n  .login {\n    grid-template-columns: 1fr;\n  }\n  .hero {\n    display: none;\n  }\n}\n\n.shell button,\n.shell input,\n.shell select,\n.shell textarea {\n  font-family: inherit;\n}\n.sidebarBrand button {\n  padding: 0;\n  width: 20px;\n  height: 24px;\n  font-size: 20px;\n}\n.sidebar nav a {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 12px;\n  color: white;\n  text-decoration: none;\n  border-radius: 4px;\n  margin-bottom: 2px;\n  white-space: nowrap;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n}\n.sidebar nav a.active {\n  font-weight: 600;\n}\n.sidebar svg {\n  flex-shrink: 0;\n}\n.support {\n  border-top: 1px solid #ffffff1a;\n  text-align: left;\n  padding: 16px 20px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.header > span strong {\n  display: inline;\n  font-weight: 500;\n  color: #24272b;\n}\n.header > span {\n  color: #70747a;\n}\n.headerUser {\n  position: relative;\n}\n.userName {\n  text-align: right;\n  max-width: 180px;\n}\n.userName small {\n  font-size: 11px;\n  color: #70747a;\n}\n.userName strong {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n.userToggle svg {\n  transform: rotate(90deg);\n  color: #70747a;\n}\n.header .userMenu {\n  position: absolute;\n  right: 0;\n  top: 44px;\n  padding: 10px 24px;\n  background: white;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  box-shadow: 0 2px 4px #0002;\n  z-index: 10;\n}\n.avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  color: white;\n  display: grid;\n  place-items: center;\n  background: #d64000;\n  font-weight: 600;\n}\n.title p {\n  line-height: 19.5px;\n}\n.month span {\n  min-width: 140px;\n  text-align: center;\n  text-transform: capitalize;\n  font-size: 14px;\n  font-weight: 500;\n}\n.company {\n  box-shadow: 0 2px 4px #0000001f;\n}\n.companyHeader h2 {\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0;\n  line-height: 28px;\n}\n.companyHeader p {\n  margin-top: 2px;\n}\n.separator {\n  margin: 0 8px;\n  color: #d9d9d9;\n}\n.metricTitle {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  align-items: start;\n  color: #d64000;\n}\n.metricTitle[data-kind='down'] {\n  color: #dc2626;\n}\n.metricTitle[data-kind='up'] {\n  color: #059669;\n}\n.metricTitle h3 {\n  margin-bottom: 8px;\n  line-height: 20px;\n}\n.metricTitle svg {\n  flex-shrink: 0;\n}\n.metricBody {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-bottom: 12px;\n}\n.metric:has(.total) {\n  min-height: 208px;\n}\n.total {\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 32px;\n  margin-bottom: 2px;\n}\n.financialRow {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  font-size: 13px;\n  line-height: 19.5px;\n  padding: 2px 0;\n}\n.financialRow strong {\n  font-weight: 500;\n}\n.metric button {\n  border: 1px solid var(--stroke-neutral-silver, #d9d9d9);\n  color: var(--text-neutral-dark, #24272b);\n  min-height: 37px;\n  height: 37px;\n  width: 100%;\n  padding: 8px 12px;\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: 4px;\n  background: #f8f9fc;\n  border-color: #d9d9d9;\n}\n.metric button:hover {\n  color: #d64000;\n  border-color: #d64000;\n}\n\n.main {\n  overflow: auto;\n  padding: 32px;\n  flex: 1;\n  position: relative;\n}\n.main[data-section='admissoes'] .title h1,\n.main[data-section='convidar'] .title h1,\n.main[data-section='configuracoes'] .title h1 {\n  font-size: 24px;\n  line-height: 32px;\n}\n.main[data-ai='true'] {\n  padding: 0;\n}\n.main[data-ai='true'] .title {\n  display: none;\n}\n.error:has(button) {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 12px;\n}\n.error:has(button) button {\n  width: auto;\n}\n@media (min-width: 1536px) {\n  .metrics {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n  }\n}\n@media (min-width: 1280px) and (max-width: 1535px) {\n  .metrics {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n@media (min-width: 768px) and (max-width: 1279px) {\n  .metrics {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n@media (max-width: 767px) {\n  .metrics {\n    grid-template-columns: 1fr;\n  }\n  .sidebar nav a > svg {\n    display: block;\n  }\n}\n\n.metricBody .financialRow {\n  padding: 0;\n}\n.metricBody .financialRow strong {\n  margin-left: auto;\n}\n.title h1 {\n  margin: 0;\n  font-size: 30px;\n  font-weight: 600;\n  line-height: 36px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.title h1 svg {\n  color: #d64000;\n}\n.companyHeader > button {\n  height: 36px;\n  min-height: 36px;\n  padding: 8px 16px;\n  font-size: 13px;\n  font-weight: 600;\n  border-radius: 4px;\n  background: #d64000;\n  letter-spacing: normal;\n}\n\n.login {\n  min-height: 100dvh;\n  display: grid;\n  grid-template-columns: minmax(0, 1.5fr) minmax(0, 1fr);\n  font-family: 'Source Sans 3', Arial, sans-serif;\n  position: relative;\n  background: #2a2b2d;\n}\n.loginBack {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  position: absolute;\n  left: 24px;\n  top: 24px;\n  color: white;\n  border: 0;\n  border-radius: 4px;\n  background: #444547;\n  padding: 6px 12px;\n  font-size: 12px;\n  font-family: inherit;\n}\n.hero {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  color: white;\n  padding: 64px 96px;\n  border-right: 1px solid #ffffff14;\n}\n.hero h1 span {\n  color: #d64000;\n}\n.hero p {\n  color: #d4d6d8;\n  margin: 0;\n  max-width: 620px;\n  font-size: 18px;\n  line-height: 1.625;\n}\n.heroBadge {\n  font-size: 12px;\n  width: fit-content;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #c64000;\n  border-radius: 16px;\n  color: white;\n  font-weight: 700;\n  padding: 4px 12px;\n  letter-spacing: 1.2px;\n}\n.heroFeatures {\n  max-width: 640px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  padding: 0;\n  list-style: none;\n  gap: 12px;\n  margin: 32px 0;\n}\n.heroFeatures li {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: #ffffff0d;\n  border: 1px solid #ffffff1a;\n  border-radius: 4px;\n  padding: 12px 16px;\n  font-weight: 500;\n  font-size: 14px;\n}\n.heroFeatures svg {\n  flex-shrink: 0;\n  color: #d64000;\n}\n.heroTrust {\n  display: flex;\n  font-size: 12px;\n  color: #d4d6d8;\n  border: 0;\n  padding: 0;\n  gap: 24px;\n}\n.heroTrust span {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n}\n.heroTrust svg {\n  color: #d64000;\n  flex-shrink: 0;\n}\n.loginForm {\n  min-width: 0;\n  color: var(--bs-body-color, #212529);\n  font-family: var(--bs-body-font-family, system-ui);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 32px;\n  background: #2a2b2d;\n}\n.brand {\n  color: white;\n  font-weight: 700;\n  font-size: 26px;\n  margin-bottom: 36px;\n}\n.loginFooter {\n  color: white;\n  display: flex;\n  gap: 16px;\n  margin-top: 32px;\n  font-size: 12px;\n}\n.loginFooter a + a {\n  border-left: 1px solid #ffffff40;\n  padding-left: 16px;\n}\n@media (max-width: 1250px) {\n  .hero {\n    padding: 48px;\n  }\n  .hero h1 {\n    font-size: 48px;\n  }\n  .heroTrust {\n    flex-wrap: wrap;\n  }\n}\n@media (max-width: 1023px) {\n  .login {\n    grid-template-columns: 1fr;\n  }\n  .hero {\n    display: none;\n  }\n  .loginForm {\n    padding: 64px 24px;\n  }\n}\n.hero h1 {\n  margin: 24px 0 16px;\n  font-weight: 700;\n  line-height: 1;\n  margin-top: 32px;\n  margin-bottom: 24px;\n  max-width: 672px;\n  font-size: 60px;\n  letter-spacing: -0.8px;\n}\n\n@media (max-width: 700px) {\n  .sidebar nav a {\n    justify-content: center;\n  }\n  .sidebar nav a span,\n  .support span {\n    display: none;\n  }\n  .header {\n    gap: 8px;\n  }\n  .header > span {\n    max-width: 120px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n  .headerUser {\n    gap: 8px !important;\n  }\n  .userName {\n    max-width: 80px;\n  }\n  .headerUser > svg {\n    display: none;\n  }\n  .error:has(button) {\n    flex-wrap: wrap;\n  }\n  .companyHeader p {\n    overflow-wrap: anywhere;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shell": `OGIyUa`,
	"sidebar": `BzVK3r`,
	"sidebarBrand": `lfLKwC`,
	"support": `WWAoN2`,
	"light": `l0MeVY`,
	"brand": `h2IrLp`,
	"active": `lVG1dp`,
	"resize": `GG1lxJ`,
	"workspace": `sMV0bk`,
	"header": `eaS5AA`,
	"title": `jSdblw`,
	"companyHeader": `itnQe3`,
	"month": `rR9zar`,
	"company": `e6ovDt`,
	"empty": `aI41Ol`,
	"metrics": `mAaj51`,
	"metric": `Q00a9C`,
	"financialRow": `FMD9yB`,
	"error": `O6bO_L`,
	"heroFeatures": `SxBjAP`,
	"login": `nmnvtX`,
	"hero": `mhj6FM`,
	"loginFooter": `cAaRIc`,
	"main": `tXDRY6`,
	"headerUser": `T1OTTM`,
	"userName": `F6tGYd`,
	"userToggle": `LevF1N`,
	"userMenu": `XKd6ZJ`,
	"avatar": `S8AbDH`,
	"separator": `aUA5bh`,
	"metricTitle": `V1awZt`,
	"metricBody": `Y5H1Zg`,
	"total": `jJoHIv`,
	"loginBack": `mAdcRG`,
	"heroBadge": `HfqjHr`,
	"heroTrust": `KfrICE`,
	"loginForm": `svp2Od`
};
module.exports = ___CSS_LOADER_EXPORT___;
